import {
    frontendChunkFile,
    frontendMatchedRouteTemplate,
} from '~/utils/frontend-diagnostics'

export default defineNuxtPlugin((nuxtApp) => {
    if (typeof window === 'undefined') return

    const config = useRuntimeConfig()
    const route = useRoute()

    function reportFrontendError(
        input: Parameters<typeof buildFrontendErrorEvent>[0]
    ) {
        const event = buildFrontendErrorEvent({
            ...input,
            routeTemplate: frontendMatchedRouteTemplate(
                route.matched?.at(-1)?.path
            ),
            releaseSha: config.public.release_sha,
        })
        const transportEvent = {
            category: event.category,
            releaseSha: event.releaseSha,
            ...(event.status === undefined ? {} : { status: event.status }),
            ...(event.routeTemplate
                ? { routeTemplate: event.routeTemplate }
                : {}),
            ...(event.chunkFile ? { chunkFile: event.chunkFile } : {}),
        }
        const body = JSON.stringify(transportEvent)

        if (navigator.sendBeacon?.('/api/frontend-error/', body)) {
            return
        }

        fetch('/api/frontend-error/', {
            method: 'POST',
            headers: { 'content-type': 'application/json' },
            body,
            keepalive: true,
        }).catch(() => {})
    }

    nuxtApp.provide('reportFrontendError', reportFrontendError)

    nuxtApp.hook('app:error', (error) => {
        reportFrontendError({
            type: 'runtime',
            message: error?.message,
            url: window.location.href,
        })
    })

    const existingErrorHandler = nuxtApp.vueApp.config.errorHandler
    nuxtApp.vueApp.config.errorHandler = (error, instance, info) => {
        reportFrontendError({
            type: info?.includes('hydrate') ? 'hydration' : 'runtime',
            message: error instanceof Error ? error.message : String(error),
            url: window.location.href,
            extra: { info },
        })

        existingErrorHandler?.(error, instance, info)
    }

    nuxtApp.hook('app:chunkError', ({ error }) => {
        reportFrontendError({
            type: 'chunk',
            chunkFile: frontendChunkFile(error, window.location.origin),
        })
    })
})
